import { useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export default function VendorSkusTable({ vendorSKUs, loading, onSearch, onOpenAddModal, onEdit, onDelete }) {
    const searchRef = useRef();

    const handleSearch = () => {
        if (onSearch) {
            onSearch(searchRef.current.value);
        }
    };

    function bodyActions(rowData) {
        return (
            <div className="flex">
                {onEdit && (
                    <button
                        onClick={() => onEdit(rowData)}
                        className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                        Edit
                    </button>
                )}
                {onDelete && (
                    <button
                        onClick={() => onDelete(rowData)}
                        className="ml-2 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                    >
                        Delete
                    </button>
                )}
            </div>
        );
    }

    if (loading) {
        return (
            <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                <div className="animate-pulse flex space-x-4">Loading...</div>
            </div>
        );
    }

    return (
        <div>
            <div className="mb-4 flex rounded-md">
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                    <input
                        type="search"
                        name="searchVendorSku"
                        id="searchVendorSku"
                        className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                        placeholder="Search vendor SKUs"
                        ref={searchRef}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") handleSearch();
                        }}
                    />
                </div>
                <button
                    type="button"
                    className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                    onClick={handleSearch}
                >
                    <MagnifyingGlassIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                    />
                </button>
                {onOpenAddModal && (
                    <button
                        type="button"
                        className="ml-2 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        onClick={onOpenAddModal}
                    >
                        Add Vendor SKU
                    </button>
                )}
            </div>
            <div className="overflow-hidden card-custom bg-white">
                <DataTable
                    value={vendorSKUs || []}
                    dataKey="id"
                    tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
                    cellClassName="p-2 border-1-bottom-gray text-sm"
                >
                    <Column header="Vendor Name" field="vendor_name" />
                    <Column header="PLU" field="product_plu" />
                    <Column header="Vendor SKU" field="vendor_sku" />
                    {(onEdit || onDelete) && <Column header="" body={bodyActions} />}
                </DataTable>
            </div>
        </div>
    );
}
